<template>
  <div class="certify-notice certify-notice-rightNow">
    <xl-dialog :width="608" @close="close" modalClass="enclosure-overlay" v-model="dialogVisible" custom-class="certify-notice_dialog">
      <div class="certify-notice_content">
        <div class="certify-notice_detail">
          <div class="certify-notice_title"><span>{{ $t('design.reminder') }}</span></div>
            {{ $t('design.certifyNotice') }} 
          </div>
        <xl-button class="certify-notice_btn" type="primary" @click="goCertify">
            {{$t('design.goCertify')}}
        </xl-button>
      </div>
      <div class="step1">{{$t('design.certifyStep1')}}</div>
      <div class="step2">{{$t('design.certifyStep2')}}</div>
      <div class="step3">{{$t('design.certifyStep3')}}</div>
    </xl-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { XlDialog, XlButton } from '@shining3d/ui-components';
import { $getLocalStorage, $setLocalStorage } from '@shining3d/common-module/utils/index.js';
import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang("@shining3d/xl-design-order");
import router from "@/router";
const dialogVisible =ref (false)
const close =()=>{
  dialogVisible.value = false;
  $setLocalStorage('isNoNeedCertifyTip', true)
}
const certifyUrl = ref('')
const open = (row)=>{
  dialogVisible.value =true
  certifyUrl.value = row.url
}

const goCertify =()=>{
	router.push(certifyUrl.value);
}
defineExpose({ open });

</script>

<style lang="scss" scoped>
.certify-notice{
  :deep(xl-dialog){
    position: relative;
  }
  :deep(.xl-dialog .el-dialog__header) {
    height: 194px !important;
    margin: 0;
    background: $default-color url('../assets/image/uniqueVerificationImg.png') no-repeat center center;
    border-bottom: none;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-size: cover;
  }
  :deep(.el-dialog__footer){
    display: none;
  }
  :deep(.el-dialog__body){
    border: none;
  }
  :deep(.el-dialog__headerbtn) {
    top: 16px;
  }
  .step1{
    position: absolute;
    top: 147px;
    left: 28px;
    color: #A5ACBE;
    width: 153px;
  }
  .step2{
    position: absolute;
    top: 147px;
    left: 222px;
    color: #A5ACBE;
    width: 153px;
  }
  .step3{
    position: absolute;
    top: 147px;
    left: 426px;
    color: #A5ACBE;
    width: 153px;
  }
  &_content {
    padding: 8px 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    word-break: break-word;
    word-break: auto-phrase;
  }
  &_title {
    height: 25px;
    font-size: 18px;
    // font-family: aliFontT85;
    @include font-family65();
    color: $color-n10;
    line-height: 25px;
    margin-bottom: 8px;
    text-align: center;
  }
  &_detail {
    min-height: 146px;
    font-size: 14px;
    font-family: $font-family;
    color: $color-n9;
    line-height: 20px;
    margin-bottom: 20px;
    text-align: left;
    &-secondary {
      color: $color-n7;
    }
    &-time {
      color: $color-b4;
      @include h4();
      @include font-family65();
    }
  }
  &_btn {
    width: 100%;
    height: 40px;
  }
}
</style>